import React from 'react';

function decodeHtmlEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
}

function TextWithLineBreaks({ text }) {
    if (typeof text !== 'string') return <div></div>;

    // Decode HTML entities
    const decodedText = decodeHtmlEntities(text);
    console.log(decodedText)

    // Split the decoded text into lines and add line breaks
    const lines = decodedText.split('\n').map((line, index, array) => (
         <span key={index}>
            {line}
            {index < array.length - 1 && <br />}
         </span>
    ));

    return <div>{lines}</div>;
}

export default TextWithLineBreaks;
